import { useQuery } from '@tanstack/react-query';

import { PolicyAttributesSearchRequestQuery, PolicyAttributesSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';

export const policyAttributesKeys = {
  search: ['policyAttributes'] as const,
  searchWithParams: (params: PolicyAttributesSearchRequestQuery) => [...policyAttributesKeys.search, params] as const,
};
const getPolicyAttributesQuery = (params?: PolicyAttributesSearchRequestQuery) => {
  if (!params) {
    return '';
  }
  const { pageLimit, pageOffset, quoteItemAttributeTypeCodeName, quoteItemTypeCodeName } = params;
  const query = new URLSearchParams();
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  if (quoteItemAttributeTypeCodeName) {
    query.append('quoteItemAttributeTypeCodeName', String(quoteItemAttributeTypeCodeName));
  }

  if (quoteItemTypeCodeName) {
    query.append('quoteItemAttributeTypeCodeName', String(quoteItemTypeCodeName));
  }

  return query.toString();
};

export const useSearchPolicyAttributes = ({
  policyId,
  params,
}: {
  policyId?: string;
  params?: PolicyAttributesSearchRequestQuery;
}) => {
  const client = useClient();
  const query = getPolicyAttributesQuery(params);
  const result = useQuery({
    enabled: !!policyId,
    queryKey: [policyId, params ? policyAttributesKeys.searchWithParams(params) : policyAttributesKeys.search],
    queryFn: () => client.get(`policy/${policyId}/attributes?${query}`).json<PolicyAttributesSearchResponse>(),
    refetchOnWindowFocus: false,
  });
  return { ...result, policyAttributes: result.data };
};
